export var VERSION = '1.5.4';
//# sourceMappingURL=version.js.map